export function initFileFields() {
    const fileFields = document.querySelectorAll('.form-file-field');
    fileFields.forEach(field => {
        const fileInput = field.querySelector('.form-file-input');
        const nameInput = field.querySelector('.form-file-name');
        if (fileInput && nameInput) {
            fileInput.addEventListener('change', fileInputChanged.bind(null, field, nameInput));
        }

        const clearBtn = field.querySelector('.form-file-clear-btn');
        if (clearBtn && fileInput) {
            clearBtn.addEventListener('click', clearBtnClicked.bind(null, fileInput));
        }
    });

    function clearBtnClicked(fileInput) {
        fileInput.value = '';
        fileInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function fileInputChanged(field, nameInput, event) {
        const file = event.currentTarget.files[0];

        if (file) {
            field.classList.add('field--file-selected');
            nameInput.value = file.name;
        }
        else {
            field.classList.remove('field--file-selected');
            nameInput.value = '';
        }
    }
}